<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :breadcrumbs="breadcrumbs"
        :title="page"
        icon="mdi-cart"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row class="white mx-1">
        <v-row class="mt-4 ml-4">
          <v-col cols="2">
            <v-text-field
                label="Order ID"
                placeholder="Enter Order ID"
                filled
                v-model="orderID"
                @input="debounceInput"
            ></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-text-field
                label="Infor"
                placeholder="Enter Name, Email"
                filled
                v-model="info"
                @input="debounceInputInfo"
            ></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-menu
                class="float-left"
                v-model="menu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    filled
                    class="mr-3 float-left"
                    v-model="date"
                    placeholder="Select Date"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable @click:clear="date = null"
                ></v-text-field>
              </template>
              <v-date-picker
                  @change="getItem"
                  v-model="date"
                  @input="menu = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col class="d-flex" cols="2">
            <v-select
                :items="statusSelect"
                item-text="name"
                item-value="value"
                filled
                label="Status"
                v-model="status1"
                @input="debounceInputStatus"
            ></v-select>
          </v-col>
        </v-row>
        <v-col cols="12" class="mt-n2">
          <v-data-table
              :headers="headers"
              :items="ordersBySearch"
              :sort-by="['id']"
              :sort-desc="true"
              :items-per-page="10"
              class="elevation-1"
          >
            <template v-slot:item.image="{ item }">
              <img :src="item.image">
            </template>
            <template v-slot:item.created_at="{ item }">
             {{formatDate(item.created_at)}}
            </template>
            <template v-slot:item.updated_at="{ item }">
              {{formatDate(item.updated_at)}}
            </template>
            <template v-slot:item.status="{ item }">
             <span v-if="item.status == 0">Received</span>
             <span v-if="item.status == 1">Paid</span>
             <span v-if="item.status == 2">Processing</span>
             <span v-if="item.status == 3">Completed</span>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="viewItem(item.id)">
                mdi-eye
              </v-icon>
              <v-icon small @click="deleteItem(item.id)">
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {DELETE_ORDER,  GET_LIST_ORDER_BY_SEARCH} from "@/store/modules/order";
import {debounce} from "debounce";

export default {
  name: "Orders",
  data() {
    return {
      page: "Orders",
      breadcrumbs: [
        {
          text: "Orders",
          disabled: false,
        },
      ],
      date: '',
      headers: [
        {text: "Order ID", value: "id", align: "start"},
        {text: "Customer Name", value: "customer_name"},
        {text: "Email", value: "customer_email"},
        {text: "Price Total (credit)", value: "total_price"},
        {text: "Date", value: "created_at"},
        {text: "Date Confirm", value: "updated_at"},
        {text: "Status", value: "status"},
        {text: "Actions", value: "actions", sortable: false},
      ],
      menu: false,
      statusSelect: [
        {name: 'Received', value: '0'},
        {name: 'Paid', value: '1'},
        {name: 'Processing', value: '2'},
        {name: 'Completed', value: '3'}],
      orderID:'',
      info:'',
      status1:''
    }
  },
  computed: {
    ...mapGetters({
      ordersBySearch: "ordersBySearch",
    })
  },
  created() {
    this.params();

  },
  methods: {
    formatDate(date) {
      if (!date) return null;
      let newDate = new Date(date);
      const [year, month, day] = [
        newDate.getFullYear(),
        newDate.getMonth() + 1,
        newDate.getDate(),
      ];
      let day_format = day > 9 ? day : `0${day}`;
      let month_format = month > 9 ? month : `0${month}`;

      return `${day_format}/${month_format}/${year}`;
    },
    getItem() {
      this.replaceOrder();
      this.params();
    },

   params() {
      let params = {
        id:this.orderID,
        keyword: this.info,
        date:this.date,
        status:this.status1?this.status1 : ''
      };
     this.$store.dispatch(GET_LIST_ORDER_BY_SEARCH, params);
    },

    replaceOrder() {
      this.$router.replace({
        query: {
          id:this.orderID,
          keyword: this.info,
          date:this.date,
          status:this.status1 ?this.status1 : ''
        }
      })
    },

    debounceInput: debounce(function (e) {
      this.orderID = e;
      this.replaceOrder();
      this.params();
    }, 200),

    debounceInputInfo: debounce(function (e) {
      this.info = e;
      this.replaceOrder();
      this.params();
    }, 200),

    debounceInputStatus: debounce(function (e) {
      this.status1 = e;
      this.replaceOrder();
      this.params();
    }, 200),

    viewItem(id) {
      this.$router.push("/orders/order_detail/" + id)
    },
    deleteItem(id) {
      confirm('Are you sure you want to delete ?') &&
      this.$store.dispatch(`${DELETE_ORDER}`, id).then(data => {
        if (data && data.status === 1) {
          this.$store.dispatch(GET_LIST_ORDER_BY_SEARCH);
        }
      })
    }
  }
}
</script>

<style scoped>

</style>